import type { NavigationGuard } from 'vue-router';
import { request } from '@/api/request';
import { withTransientRetry } from '@/modules/query/utils';
import type { ReviewSharingCommunity } from '@@/packages/shared/types/models/reviewSharing';

export const requireReviewSharingEnabled: NavigationGuard = async (_to, _from, next) => {
  try {
    const { data } = await withTransientRetry(() =>
      request<{ communities: ReviewSharingCommunity[] }>('GET', '/review-sharing/communities'),
    );
    if (!data.communities.some((community) => community.enabled)) {
      return next({ name: 'settings-account' });
    }
    return next();
  } catch {
    return next({ name: 'settings-account' });
  }
};
